// extracted by mini-css-extract-plugin
export default {"mobileHeader":"mobileHeader__Dk1lm","backButton":"backButton__NH0jG"};